module.exports = __webpack_public_path__ + "img/2.02dd68b9.png";